import React from "react";

/**
 * Table with sticky header, row selection, hover, empty/loading rows.
 * This is a low-level primitive — callers compose rows and header cells
 * directly. Wrapper adds a border + rounded corners consistently.
 */
export function Table({ children, className = "", ...rest }) {
  return (
    <div className="ds-table-wrap">
      <table className={`ds-table ${className}`.trim()} {...rest}>{children}</table>
    </div>
  );
}

/** Empty row helper — colSpan derived from parent. */
export function TableEmpty({ colSpan, children = "No records match your filter." }) {
  return <tr><td colSpan={colSpan} className="ds-table-empty">{children}</td></tr>;
}

/** Loading row helper. */
export function TableLoading({ colSpan, children = "Loading…" }) {
  return <tr><td colSpan={colSpan} className="ds-table-loading">{children}</td></tr>;
}
